<template>
  <div class="booking-confirmation">
    <div class="row">
      <div class="col-lg-6 col-lg-offset-3">
        <div class="box">
          <div class="box-body">
            <div class="text-center">
              <i class="fa fa-check-circle fa-bigger green"></i>
              <h2>Booking Complete</h2><br/>
              <div><span class="bubble">Reservation #: {{ Reservation.reservationId }}</span></div><br/>
              <div class="email-pref" v-if="emailPrefs">
                <hr/>
                <p>
                  We'll send you a confirmation email shortly to: <span class="email">{{ email }}</span>
                </p>
              </div>
              <hr/>
              <div class="header">Details</div>
              <p>
                <strong>Driver:</strong> {{ driver }}
              </p>
              <img class="img-thumbnail" v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( Car.CarType.AmazonImage.objectKey ? Car.CarType.AmazonImage.objectKey : 'spacer.gif' ) + '?v=' + new Date().getTime()"/><br/><br/>
              <p>A <span class="car =">{{ Car.color }} {{ Car.CarType.name }} (<strong>{{ Car.rego }}</strong> - {{ Car.name }})</span> will be ready and waiting for you:</p>
              <div class="row">
                <div class="col-md-6 col-md-offset-3">
                  <div class="callout callout-success">
                    <strong>Start Date: </strong>
                    {{ Reservation.startDate | date_format Reservation.Lot.timezone }}
                  </div>
                  <div class="callout callout-success">
                    <strong>End Date: </strong>
                    {{ Reservation.endDate | date_format Reservation.Lot.timezone }}
                  </div>
                  <p><strong>Total Time:</strong> {{ priceBreakdown.cost.days }} Day(s), {{ priceBreakdown.cost.hours }} Hour(s)</p>
                </div>
              </div>
              <hr/>
              <p>
                <div class="header">Where can I find the car?</div>
                {{ Reservation.Lot.address }} <br/> {{ Reservation.Lot.addressMemo }}
              </p>
              <p>
                <img class="google-map" v-bind:src="'https://maps.googleapis.com/maps/api/staticmap?center='+ Reservation.Lot.latitude +','+ Reservation.Lot.longitude +'&zoom=17&size=250x250&maptype=roadmap&markers=color:red%7Clabel:C%7C'+ Reservation.Lot.latitude +','+ Reservation.Lot.longitude +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" alt="Lot Location">
              </p>
              <p>
                <a v-bind:href="'https://www.google.com/maps?q='+ Reservation.Lot.latitude +','+ Reservation.Lot.longitude" target="_blank" class="btn btn-default btn-sm"> <i class="fa fa-map-marker fa-fw"></i> View on Google Maps</a>
              </p>
              <template v-if="Reservation.LotRelocationUuid">
                <hr/>
                <p>
                  <div class="header">Where do I return the car?</div>
                  {{ Reservation.DestinationLot.address }} <br/>
                  {{ Reservation.DestinationLot.addressMemo }}
                </p>
                <p>
                  <img class="google-map" v-bind:src="'https://maps.googleapis.com/maps/api/staticmap?center='+ Reservation.DestinationLot.latitude +','+ Reservation.DestinationLot.longitude +'&zoom=17&size=250x250&maptype=roadmap&markers=color:red%7Clabel:C%7C'+ Reservation.DestinationLot.latitude +','+ Reservation.DestinationLot.longitude +'&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'" alt="DestinationLot Location">
                </p>
                <p>
                  <a v-bind:href="'https://www.google.com/maps?q='+ Reservation.DestinationLot.latitude +','+ Reservation.DestinationLot.longitude" target="_blank" class="btn btn-default btn-sm"> <i class="fa fa-map-marker fa-fw"></i> View on Google Maps</a>
                </p>
              </template>
              <hr/>
              <p>
                <div class="header">Price Breakdown</div>
              </p>
            </div>
            <div class="row text-left">
              <div class="col-md-8 col-md-offset-2">
                <price-table :price-breakdown="priceBreakdown" :show-details="false"></price-table>
              </div>
            </div>
            <div class="text-center">
              <template v-if="Reservation.memo">
                <p>
                  <div class="header">Memo</div>
                </p>
                <div class="row">
                  <div class="col-md-6 col-md-offset-3">
                    <div class="memo">{{ Reservation.memo }}</div>
                  </div>
                </div>
              </template>
              <hr/>
              <p class="footer">
                If you have any questions about this booking, just give us a call
                at {{ Car.Organization.companyPhone }}. We're always happy to help!
              </p>
              <p class="footer">
                <span class="happy">Happy Driving!</span><br/>
                <em>The {{ Car.Organization.companyName }} Team</em>
              </p>
              <hr/>
            </div>
          </div>
        </div>
        <span class="time">
          This booking was registered in our system on
          {{ Reservation.createdAt | date_format Reservation.Lot.timezone }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PriceTable from './displays/PriceTable.vue'
export default {
  name: 'BookingConfirmation',
  components: {
    PriceTable
  },
  data () {
    return {
      driver: '',
      Reservation: {
        Lot: {},
        ReservationPromo: {}
      },
      Car: {
        CarType: {
          AmazonImage: {}
        },
        Organization: {}
      },
      email: '',
      emailPrefs: true,
      priceBreakdown: {
        cost: {},
        rate: {},
        reservation: {}
      }
    }
  },
  route: {
  },
  ready () {
    this.getReservation()
  },
  methods: {
    getReservation () {
      let resId = this.$route.params.reservationId
      let params = this.$route.params
      let authType = this.$route.authType
      this.$http.get(`${authType}/reservation/confirm/${resId}`, {
        params
      }).then(({ data }, status, request) => {
        this.Reservation = data.reservation
        this.driver = data.reservation.Account.dropdownLabel
        this.email = data.email
        this.emailPrefs = data.emailPrefs
        this.Car = data.reservation.Car
        this.updateCost()
      })
    },
    updateCost () {
      let carUuid = this.Car.uuid
      let startDate = this.Reservation.startDate
      let authType = this.$route.authType
      let extras = this.Reservation.extras
      let endDate = this.Reservation.endDate
      let extraCredit = 0
      let alreadyPaid = 0
      this.$http.post(`${authType}/update-cost`, {
        carUuid,
        startDate,
        endDate,
        extras,
        extraCredit,
        alreadyPaid,
        promo: this.Reservation.ReservationPromo ? this.Reservation.ReservationPromo.code : null,
        percentDiscount: this.Reservation.percentDiscount || 0
      }).then((response, status, request) => {
        this.priceBreakdown.rate = response.data.rate.rate
        this.priceBreakdown.cost = response.data.cost
        this.priceBreakdown.reservation = this.Reservation
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BookingConfirmation.vue?dd461d62